import {
  VStack,
  Tabs,
  TabList,
  Tab,
  TabIndicator,
  Divider,
  TabPanels,
  TabPanel,
  Box,
} from '@chakra-ui/react';

import { TaskDocuments } from '.';
import { useGetAllFormFeaturesQuery } from '../../../services';
import { CenteredSpinner } from '../../../components';
import { stringToPascalCase } from '../../../utils';
import { useEffect, useState } from 'react';
import { FileStatus, Workflow } from '../../../models';
import { useUploadFiles } from '../../../hooks';

export const NewTaskFeaturesTabs = ({
  workflowData,
  files,
  setFiles,
}: {
  setFiles: React.Dispatch<
    React.SetStateAction<
      {
        file: File;
        status: FileStatus;
      }[]
    >
  >;
  files: { file: File; status: FileStatus }[];
  workflowData: Workflow;
}) => {
  const [activeFormFeatures, setActiveFormFeatures] = useState<
    { id: number; name: string }[]
  >([]);

  const { data: formFeatures, isLoading: isFormFeaturesLoading } =
    useGetAllFormFeaturesQuery();

  useEffect(() => {
    if (formFeatures?.data) {
      setActiveFormFeatures(
        formFeatures.data
          .filter(
            ({ id }) =>
              workflowData.form.features.find(
                feature => feature.featureTypeId === id
              )?.isEnabled
          )
          .map(({ id, name }) => ({ id, name }))
      );
    }
  }, [formFeatures?.data]);

  return activeFormFeatures.find(feature => feature.name === 'documents') ? (
    <VStack
      bg="white"
      border="1px"
      borderColor="custom_gray.10"
      borderRadius="md"
      h="full"
      flexBasis="25%"
      hidden={!activeFormFeatures.length}
      align="stretch"
    >
      {isFormFeaturesLoading ? (
        <CenteredSpinner />
      ) : (
        <Tabs
          position="relative"
          variant="unstyled"
          colorScheme="orange"
          bg="white"
          borderRadius="md"
          w="full"
          h="full"
        >
          <Box px="4">
            <TabList justifyContent="space-evenly">
              {[
                activeFormFeatures.find(
                  feature => feature.name === 'documents'
                ),
              ].map(({ name }) => (
                <Tab
                  key={name}
                  fontSize="sm"
                  fontWeight="semibold"
                  color="custom_gray.1"
                  _selected={{ color: 'custom_orange.2' }}
                >
                  {stringToPascalCase(name)}
                </Tab>
              ))}
            </TabList>

            <TabIndicator
              mt="-1.5px"
              height="2px"
              bg="custom_orange.2"
              borderRadius="1px"
            />

            <Divider />
          </Box>

          <TabPanels h="full">
            {/* we do that to keep the same sorting of the tabs above */}
            <TabPanel h="92%" overflowY="scroll">
              <TaskDocuments files={files} setFiles={setFiles} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </VStack>
  ) : (
    <></>
  );
};
